import React from 'react';
import FileBase64 from '../util/Input64';
import { Input, Icon, Tooltip, Button, Popover } from 'antd';
import SERVER_URL from '../Global';

class HandleHr extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user: this.props.token,
            hr: [],
            hrCreated: false,
            hrName: '',
            hrSurname: '',
            hrId: '',
            hrSaved: false,
            hrLoaded: false,
            hrImage: null,
            imageType: null,
            hrSameName: [],
            visible: false
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSurnameChange = this.handleSurnameChange.bind(this);
        this.saveHr = this.saveHr.bind(this);
        this.checkHrname = this.checkHrname.bind(this);
        this.saveHrAnyway = this.saveHrAnyway.bind(this);
        this.choosehr = this.choosehr.bind(this);
        this.hide = this.hide.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
    }

    //checkForDouble
    checkHrname() {
        let uniquename = this.state.hrName + " " + this.state.hrSurname

        fetch(
            `${SERVER_URL + 'api/hr/list?lang=en'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "uniquename": uniquename,
                    "page": 1,
                    "pageSize": 15,
                    "Status": 1
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ hrSameName: res.data, visible: true })
                }
            })
    }

    deleteImage() {
        fetch(
            `${SERVER_URL + 'api/hr/image/hard/' + this.state.hrId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
            }
        )

        this.setState({ hrImage: null })
    }

    handleNameChange(event) {
        this.setState({ hrName: event.target.value, hrSaved: false });

        if (event.target.value.length === 0) {
            this.setState({ hrName: '' })
        }
        if (this.state.hrSameName.length > 0 ) {
        }
    }

    handleSurnameChange(event) {
        this.setState({ hrSurname: event.target.value, hrSaved: false });

        if (event.target.value.length === 0) {
            this.setState({ hrSurname: '' })
        }
    }

    saveHr() {
        this.checkHrname()
        if (this.state.hrSameName.length == 0) {
            if (this.state.hrCreated) {
                fetch(`${SERVER_URL + 'api/hr'}`, {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`,
                    },
                    body: JSON.stringify({
                        'name': this.state.hrName,
                        'surname': this.state.hrSurname,
                        'hrid': this.state.hrId,
                        'PortraitImage': this.state.hrImage,
                        "imageType": this.state.imageType,
                        "Status": 1,
                    })
                })
                this.setState({ hrSaved: true })
            }
            else {
                fetch(`${SERVER_URL + 'api/hr'}`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`,
                    },
                    body: JSON.stringify({
                        'name': this.state.hrName,
                        'surname': this.state.hrSurname,
                        'PortraitImage': this.state.hrImage,
                        "imageType": this.state.imageType,
                        "Status": 1,
                    })
                }).then(response => response.json())
                    .then(res => {
                        this.setState({ hrCreated: true, hrId: res.data, hrCreated: true, hrSaved: true });
                    })
            }
            this.sendHrSaved()
        }
    }

    saveHrAnyway() {
        fetch(
            `${SERVER_URL + "api/hr"}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    'name': this.state.hrName,
                    'surname': this.state.hrSurname,
                    'PortraitImage': this.state.hrImage,
                    "imageType": this.state.imageType,
                    "Status": 1,
                })
            }
        ).then(response => response.json())
            .then(res => {
                this.setState({ hrCreated: true, hrId: res.data, hrSaved: true })
            })
        this.sendHrSaved()
    }

    getFiles(files) {
        if (files.length != 0) {
            this.setState({ hrImage: files.base64, imageType: files.type, hrSaved: false });
        } else {
            this.setState({ hrImage: null });
        }
    }

    sendHrSaved = () => {
        this.props.parentCallbackHrSaved(true);
    }

    choosehr(hr) {
        this.setState({ hrId: hr.hrId, hrName: hr.name, hrSurname: hr.surname, hrImage: hr.portraitImage, imageType: hr.imageType, hrCreated: true, visible: false, choosenOne: true }, this.saveHrAnyway)
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    };

    render() {

        let name = this.state.hrName !== null ? this.state.hrName : ''

        let surname = this.state.hrSurname !== null ? this.state.hrSurname : ''

        let allSavedBlock = <p>Everything is already Saved</p>

        let mandatoryNotMet = <p>One or more Mandatory Fields are empty</p>

        let mandatoryName = this.state.hrName != null && this.state.hrName != '' ? <Icon type="check-circle" /> : <Tooltip title="This field is mandatory"><Icon type="exclamation-circle" /></Tooltip>

        let mandatorySurname = this.state.hrSurname != null && this.state.hrSurname != '' ? <Icon type="check-circle" /> : <Tooltip title="This field is mandatory"><Icon type="exclamation-circle" /></Tooltip>

        let hrSave = this.state.hrSaved ? <div className="saveButtonBox"><Popover content={allSavedBlock}><Button disabled className="saveButtonHrWizard" icon="save">Save Hr</Button></Popover></div> : this.state.hrName !== null && this.state.hrSurname !== null ? <div className="saveButtonBox"> <Button onClick={this.saveHr} className="saveButtonHrWizard" icon="save">Save Hr</Button></div> : <div className="saveButtonBox"><Popover content={mandatoryNotMet}><Button disabled onClick={this.saveHr} className="saveButtonHrWizard" icon="save">Save Hr</Button></Popover></div>

        let imageContent = <div><p className="fakeLink" style={{ display: 'block' }} onClick={this.deleteImage}><Icon style={{ color: 'red' }} type="close" /> Remove image</p><img className="popoverImage" src={'data:' + this.state.imageType + ';base64,' + this.state.hrImage} /></div>

        let iconImage = this.state.hrImage !== null && this.state.hrImage !== '' ? <Popover content={imageContent}><div style={{ backgroundImage: 'url(' + `${'data:' + this.state.imageType + ';base64,' + this.state.hrImage}` + ')' }} className="trueWizardImage"></div></Popover> : <div className="fakeWizardImage">{this.state.hrName.charAt(0)}</div>

        let newHrorOldHrTitle = <div style={{ padding: '0px 0px 6px' }}><p style={{ marginBottom:'0px' }}><b>Name already used</b></p></div>

        let newHrorOldHrBody =
            <div style={{ padding: '0px 14px '}}>
                <ul>{this.state.hrSameName.map(hr =>
                    <li key={hr.hrId}>
                        <p className="fakeLink" style={{ marginBottom:'5px' }} onClick={() => this.choosehr(hr)} >{hr.fullName} - {
                            hr.brHrRoleOfficies.map(br => {
                                if (br.role != null) {
                                    if (br.office != null) {
                                        if (br.office.company != null) {
                                            return <span key={br.hroId}>{br.role.name} - {br.office.company.name}; </span>
                                        }
                                    }
                                }
                            })
                        }
                        </p>
                    </li>
                )}</ul>
                <div>
                    <button onClick={this.saveHrAnyway} className="saveButtonBox fakeLink">Save Anyway</button> 
                    <button style={{ float: "right" }} className="saveButtonBox fakeLink">Close</button>
                </div>
            </div>

        let nameSurname = !this.state.disabledHrDetails ?
            <div style={{ display: 'inline-flex', width: '100%' }} className="nameSurnameBox">
                <Input autoComplete="new-password" value={name} className="hrName contactText" allowClear={true} placeholder="Name" onChange={this.handleNameChange} />
                {mandatoryName}
                <Popover
                    content={<a onClick={this.hide}>{newHrorOldHrBody}</a>}
                    title={newHrorOldHrTitle}
                    trigger="click"
                    visible={this.state.visible}
                >
                    <Input autoComplete="new-password" style={{ width:'calc(52% - 32px)' }} value={surname} onBlur={this.checkHrname} className="hrSurname contactText" allowClear={true} placeholder="Surname" onChange={this.handleSurnameChange} />
                </Popover>
                {mandatorySurname}
            </div> : null

        let nameSurnameDetail =
            <div style={{ width: '48%' }}>
                <div style={{ width: '100%', display: 'inline-flex' }}>
                    <Tooltip placement="topLeft" title="Insert here the HR's name and surname">
                        <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Hr Details:</h4>
                    </Tooltip>
                </div>
                {nameSurname}
            </div>

        let hrPhoto = 
            <div style={{ width: '48%', marginLeft: '4%' }}>
                <div style={{ width: '100%', display: 'inline-flex' }}>
                    <Tooltip placement="topLeft" title="Insert here the HR's image">
                        <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Hr Image:</h4>
                    </Tooltip>
                </div>
                <div className="wizardInputs">
                    <FileBase64 onDone={this.getFiles.bind(this)} />
                    <div>{iconImage}</div>
                </div>
                <span id="wrongSize" className="warningWizard" >Warning, file size is too big (max 150 kb)</span>
                <span id="wrongExtension" className="warningWizard">Warning, only .png, .jpg, .jpeg and .svg accepted</span>
            </div>

        return (
            <div className="modifyHrBox" style={{ width: '100%' }}>
                <h3 style={{ fontSize: '20px', minHeight: '1.2em' }}>{name} {surname}</h3>
                <div className={"modifyHr" + this.state.hrSaved}>
                    <div style={{display:'inline-flex', width: '100%'}}>
                        {nameSurnameDetail}
                        {hrPhoto}
                    </div>
                    {hrSave}
                </div>
            </div>
        );
    }
}

export default HandleHr;


// WEBPACK FOOTER //
// ./src/Hr/HandleHr.js